import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Fade } from 'react-awesome-reveal';
import { Icon } from '../Icon';
import styles from './ToggleSwitcher.css';

const cx = classnames.bind(styles);

function ToggleSwitcher({checked, className, onChange, name}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className),
        checked
    });

    const handleClick = () => {
        onChange?.(name, !checked);
    };

    return (
        <label
            className={classes}
        >
            <input type='checkbox' checked={checked} onChange={handleClick} />
            <div className={styles.slider}>
                <span>{checked ? 'Yes' : 'No'}</span>
            </div>
        </label>
    );
};

ToggleSwitcher.propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired
};

ToggleSwitcher.defaultProps = {
    onChange: null,
    className: ''
};

export {
    ToggleSwitcher
};
